import axios from 'axios'
const url = process.env.REACT_APP_BASE_URL
const NEWurl = process.env.REACT_APP_NEW_BASE_URL

const LOGIN = 'auth/login'
const CHANGEPassword = 'users/change-password'
const NEWPLANT = 'plant'
const UPDATEPLANT = 'plant/plant/'
const DELETEPLANT = 'plant/'
const DEVICE = 'equipment/devicetypes'
const TECHGRAPH = 'plant/graph/graph-data?plantId='
const HOMEGRAPH = 'plant/graph/graph-data/'
const NOTIFICATIONALL = 'notifications/faulty?plantId=all'
const NOTIFICATIONBYPLANT = 'notifications/faulty?plantId='

export const BREVO_API_KEY =
  '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'

export const expressURL = 'https://staging-backend-v3-express.de.energy'
// export const expressURL = 'https://staging-backend-v3-express.de.energy'
// export const expressURL = 'htt'

const NEWTECHGRAPH = 'api/graph-v2/'
const NEWAVGGRAPH = 'api/graph-average/'

// pass arguments along with user type EG: user = "admin"
const Token = localStorage.getItem('accessToken')
const headers = { Authorization: `Bearer ${Token}` }

export const login = async (params) => {
  try {
    const response = await axios.post(url + LOGIN, {
      email: params.email,
      password: params.password,
    })
    return response
  } catch (error) {
    return error
  }
}

export const ChangePassword = async (params, token) => {
  try {
    const response = await axios.post(
      url + CHANGEPassword,
      {
        userId: params.userId,
        oldPassword: params.oldPassword,
        newPassword: params.newPassword,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const Createnewplant = async (params, token) => {
  try {
    const response = await axios.post(url + NEWPLANT, params, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}
export const FetchPlantList = async (params, token, Order) => {
  try {
    const response = await axios.get(
      url + NEWPLANT + `?date=${params}&plantSizeOrder=${Order}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )

    return response
  } catch (error) {
    return error
  }
}

export const FetchPlantSearch = async (date, name, type, token, Order) => {
  try {
    const response = await axios.get(
      url +
        NEWPLANT +
        `?date=${date}&plantNameSearch=${name}&plantType=${type}&plantSizeOrder=${Order}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )

    return response
  } catch (error) {
    return error
  }
}

export const Updatenewplant = async (params) => {
  try {
    const response = await axios.put(
      url + UPDATEPLANT + params?.Id,
      params?.values,
      { headers: { Authorization: `Bearer ${params?.token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const Deletenewplant = async (params, token) => {
  try {
    const response = await axios.delete(url + DELETEPLANT + params, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}

export const FetchDeviceList = async (token) => {
  try {
    const response = await axios.get(url + DEVICE, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}

export const FetchTechnicalGraph = async (params) => {
  try {
    const response = await axios.get(
      url + TECHGRAPH + params + '&yieldOrEtodayOrEnergyM=etoday',
      { headers }
    )
    return response
  } catch (error) {
    return error
  }
}
export const FetchYeildGraph = async (params) => {
  try {
    const response = await axios.get(
      url + TECHGRAPH + params + '&yieldOrEtodayOrEnergyM=yield',
      { headers }
    )
    return response
  } catch (error) {
    return error
  }
}
export const FetchEnergyMGraph = async (params) => {
  try {
    const response = await axios.get(
      url + TECHGRAPH + params + '&yieldOrEtodayOrEnergyM=energyM',
      { headers }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchGraphBysort = async (
  PlantID,
  technicalDate,
  sortType,
  graphType,
  token
) => {
  try {
    const response = await axios.get(
      url +
        TECHGRAPH +
        PlantID +
        `&yieldOrEtodayOrEnergyM=${graphType}&fromDate=${technicalDate}&period=${sortType}&id=all`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchPRGraphBysort = async (
  PlantID,
  technicalDate,
  sortType,
  graphType,
  token
) => {
  try {
    const response = await axios.get(
      url +
        `graph/graph-data?fromDate=${technicalDate}&period=${sortType}&resultType=PR&plantId=${PlantID}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchHomePRGraphBysort = async (
  technicalDate,
  sortType,
  graphType,
  token
) => {
  try {
    const response = await axios.get(
      url +
        `graph/graph-data?fromDate=${technicalDate}&period=${sortType}&resultType=PR`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchPRGraphByID = async (
  PlantID,
  technicalDate,
  sortType,
  graphType,
  deviceID,
  token
) => {
  try {
    const response = await axios.get(
      url +
        `graph/graph-data?fromDate=${technicalDate}&period=${sortType}&plantId=${PlantID}&resultType=PR&deviceId=${deviceID}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchHomeGTIGraphBysort = async (
  technicalDate,
  sortType,
  devtype,
  token
) => {
  try {
    const response = await axios.get(
      url +
        `graph/graph-data?fromDate=${technicalDate}&period=${sortType}&resultType=${devtype}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchGraphByminimumguarantee = async (
  PlantID,
  technicalDate,
  token,
  duration
) => {
  try {
    const response = await axios.get(
      url +
        NEWPLANT +
        '/graph/minimum-guarantee-per-month?id=' +
        PlantID +
        `&period=${duration}&fromDate=${technicalDate}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchGraphByInverterguarantee = async (
  PlantID,
  technicalDate,
  token,
  duration
) => {
  try {
    const response = await axios.get(
      url +
        NEWPLANT +
        '/graph/inverter-guarantee-per-month?id=' +
        PlantID +
        `&period=${duration}&fromDate=${technicalDate}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchGraphByExpectedGen = async (
  PlantID,
  technicalDate,
  token,
  duration
) => {
  try {
    const response = await axios.get(
      url +
        NEWPLANT +
        '/graph/expected-generation?plantId=' +
        PlantID +
        `&period=${duration}&fromDate=${technicalDate}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchGraphBYid = async (
  PlantID,
  technicalDate,
  sortType,
  graphType,
  devId,
  token
) => {
  try {
    const response = await axios.get(
      url +
        TECHGRAPH +
        PlantID +
        `&yieldOrEtodayOrEnergyM=${graphType}&fromDate=${technicalDate}&period=${sortType}&id=${devId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchGhiGraphBYid = async (
  PlantID,
  technicalDate,
  sortType,
  graphType,
  token
) => {
  try {
    const response = await axios.get(
      url +
        `plant/graph/graph-data-ghi?yieldOrEtodayOrEnergyM=${graphType}&fromDate=${technicalDate}&period=${sortType}&plantId=${PlantID}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchHomeGraph = async (
  technicalDate,
  sortType,
  graphType,
  token
) => {
  try {
    const response = await axios.get(
      url +
        HOMEGRAPH +
        `all?yieldOrEtodayOrEnergyM=${graphType}&fromDate=${technicalDate}&period=${sortType}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchPlantCountGraph = async (technicalDate, sortType, token) => {
  try {
    const response = await axios.get(
      url +
        NEWPLANT +
        `/graph/plants-per-month?fromDate=${technicalDate}&period=${sortType}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}
export const FetchPlantSizeGraph = async (technicalDate, sortType, token) => {
  try {
    const response = await axios.get(
      url +
        NEWPLANT +
        `/graph/plantsize-per-month?fromDate=${technicalDate}&period=${sortType}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchDashboarddata = async (userId, token) => {
  try {
    const response = await axios.get(url + NEWPLANT + `/dashboard/stats`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}

export const Addlogdta = async (data, token) => {
  // console.log(token, "token----token")
  try {
    const response = await axios.post(url + NEWPLANT + '/log', data, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}

export const Getlogdta = async (token) => {
  try {
    const response = await axios.get(url + NEWPLANT + '/log/getAllLog', {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}

export const GetlogPlant = async (plantName, token) => {
  try {
    const response = await axios.get(url + NEWPLANT + `/getLog/${plantName}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}

export const GetMonthlyReport = async (plantId, token, fromDate, toDate) => {
  try {
    const response = await axios.get(
      url +
        NEWPLANT +
        `/report-v2/getMonthlyReport/${plantId}/${fromDate}/${toDate}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const GetMonthlyInvoice = async (plantId, token, fromDate, toDate) => {
  try {
    const response = await axios.get(
      url +
        NEWPLANT +
        `/report-v2/getTaxInvoice/${plantId}/${fromDate}/${toDate}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const GetUserLogReport = async (plantId, token, fromDate, toDate) => {
  try {
    const response = await axios.get(url + `logs`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}

export const GetUserLogReportByFilter = async (token, fromDate, toDate) => {
  try {
    const response = await axios.get(
      url + `logs?fromDate=${fromDate}&toDate=${toDate}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchDeviceStatus = async (plantId, token) => {
  try {
    const response = await axios.get(url + `plant/device-status/${plantId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}

export const FetchIrradianceGraphByID = async (
  PlantID,
  technicalDate,
  sortType,
  graphType,
  token
) => {
  try {
    const response = await axios.get(
      url +
        `graph/graph-data?fromDate=${technicalDate}&period=${sortType}&plantId=${PlantID}&resultType=IRRADIATION`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchAllNotification = async (token) => {
  try {
    const response = await axios.get(
      url + NOTIFICATIONALL
      // { headers: { 'Authorization': `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchNotificationByPlant = async (plantId) => {
  try {
    const response = await axios.get(
      url + NOTIFICATIONBYPLANT + plantId
      // { headers: { 'Authorization': `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchUsersList = async (token) => {
  try {
    const response = await axios.get(
      url + `users?role=client&limit=10&offset=0`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchInternalUsersList = async (token) => {
  try {
    const response = await axios.get(
      url + `users?role=sub_admin&limit=10&offset=0`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const AddExternalUser = async (data, token) => {
  try {
    const response = await axios.post(url + 'users', data, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}

export const AddInternalUser = async (data, token) => {
  try {
    const response = await axios.post(url + 'users', data, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}

export const AddPlantToUser = async (data, token) => {
  // console.log(token, "token----token")
  try {
    const response = await axios.post(url + 'users/plant/add', data, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}

export const DeleteUser = async (userId, token) => {
  try {
    const response = await axios.delete(url + `users/${userId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}

export const RemovePlantToUser = async (data, token) => {
  try {
    const response = await axios.post(url + 'users/plant/remove', data, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}

// new API changes

export const FetchGraphBysortNew = async (
  PlantID,
  fromDate,
  sortType,
  graphType,
  token,
  toDate,
  roofID,
  deviceID
) => {
  try {
    const response = await axios.get(
      NEWurl +
        NEWTECHGRAPH +
        PlantID +
        `/${graphType}/${fromDate}/${sortType}/${roofID}/${toDate}/${deviceID}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )

    return response
  } catch (error) {
    console.log(error, 'err')
    return error
  }
}

export const fetchInverterEnergyData = async (
  plantId,
  startDate,
  endDate,
  duration,
  type
) => {
  console.log(
    'Inverter Energy Data:',
    plantId,
    startDate,
    endDate,
    duration,
    type
  )
  try {
    const url = `https://staging-backend-v3-express.de.energy/api/inverterquarterhourlydata/plant/${plantId}`
    // const url = `https://staging-backend-v3-express.de.energy/api/inverterquarterhourlydata/plant/${plantId}`

    const response = await axios.get(url, {
      params: {
        startDate: startDate,
        endDate: endDate,
        duration: duration,
        type: type,
      },
    })

    return response
  } catch (error) {
    console.error('Error fetching inverter energy data:', error)
    throw new Error('Failed to fetch inverter energy data')
  }
}

export const fetchEnergyMeterData = async (
  plantId,
  startDate,
  endDate,
  duration,
  type
) => {
  try {
    const url = `https://staging-backend-v3-express.de.energy/api/energyMeterQuarterHourly/searchByPlantId`
    // const url = `https://staging-backend-v3-express.de.energy/api/energyMeterQuarterHourly/searchByPlantId`

    const response = await axios.get(url, {
      params: {
        plantId,
        startDate: startDate,
        endDate: endDate,
        duration: duration,
        type: type,
      },
    })

    return response
  } catch (error) {
    console.error('Error fetching energy meter data:', error)
    return error
  }
}

// Function to fetch GHI data
export const fetchGHIData = async (
  plantId,
  startDate,
  endDate,
  duration,
  type
) => {
  try {
    // const baseUrl = 'https://staging-backend-v3-express.de.energy' // Fixed URL (added colon instead of space and a port number if needed)
    const baseUrl = 'https://staging-backend-v3-express.de.energy' // Fixed URL (added colon instead of space and a port number if needed)
    const url = `${baseUrl}/api/ghiQuarterHourlyData/byPlantIdAndTimeRange?plantId=${plantId}&startTime=${encodeURIComponent(
      startDate
    )}&endTime=${encodeURIComponent(endDate)}&duration=${duration}&type=${type}`

    const response = await axios.get(url)

    return response.data
  } catch (error) {
    console.error('Error fetching GHI data:', error)
    throw error
  }
}

// Function to fetch GTI data
export const fetchGTIData = async (
  plantId,
  startDate,
  endDate,
  duration,
  type
) => {
  try {
    // const baseUrl = 'https://staging-backend-v3-express.de.energy' // Fixed URL (added colon instead of space and a port number if needed)
    const baseUrl = 'https://staging-backend-v3-express.de.energy' // Fixed URL (added colon instead of space and a port number if needed)
    const url = `${baseUrl}/api/gtiquarterhourlydata/plant?plantId=${plantId}&startDate=${encodeURIComponent(
      startDate
    )}&endDate=${encodeURIComponent(endDate)}&duration=${duration}&type=${type}`

    const response = await axios.get(url)
    //console.log("FetchGTIData:", response.data)

    return response.data
  } catch (error) {
    console.error('Error fetching GTI data:', error)
    throw error
  }
}

export const FetchHomeAvgGraphBysortNew = async (
  fromDate,
  sortType,
  graphType,
  token,
  toDate,
  deviceId
) => {
  try {
    const response = await axios.get(
      NEWurl +
        NEWAVGGRAPH +
        `${graphType}/${fromDate}/${sortType}/all/${toDate}/${deviceId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    console.log(error, 'err')
    return error
  }
}

export const FetchAggregatedYieldAndGti = async (
  startDate,
  duration,
  type,
  token,
  endDate = 'all'
) => {
  try {
    let apiDuration
    switch (duration) {
      case '1m':
        apiDuration = '1M'
        break
      case '3m':
        apiDuration = '3M'
        break
      case '6m':
        apiDuration = '6M'
        break
      case 'year':
        apiDuration = '1Y'
        break
      case 'ytd':
        apiDuration = 'YTD'
        break
      case 'custom':
        apiDuration = 'CUST'
        break
      case 'mtd':
        apiDuration = 'MTD'
        break
      default:
        apiDuration = '1M'
    }
    // const baseUrl = 'https://staging-backend-v3-express.de.energy' // Fixed URL (added colon instead of space and a port number if needed)
    const baseUrl = 'https://staging-backend-v3-express.de.energy'
    const response = await fetch(
      `${baseUrl}/api/gtiquarterhourlydata/getAggregatedYieldAndGti?startDate=${startDate}&duration=${apiDuration}&type=${type}&endDate=${endDate}`,
      {
        method: 'GET',
      }
    )

    if (!response.ok) {
      const errorText = await response.text()
      console.error(`API error (${response.status}):`, errorText)
      throw new Error(`API error: ${response.status}`)
    }

    const data = await response.json()
    console.log(`Received ${data.length} data points for ${type}`)
    return { data }
  } catch (error) {
    console.error('Error fetching aggregated data:', error)
    return { data: [] }
  }
}

// export const FetchPlantListNew = async (params, token, Order) => {
//   try {
//     const newdate = `${params}T00:00:00+05:30`
//     const encodedDate = encodeURIComponent(newdate)
//     const response = await axios.get(
//       NEWurl + `api/plant?date=${encodedDate}&plantSizeOrder=${Order}`,
//       { headers: { Authorization: `Bearer ${token}` } }
//     )

//     return response
//   } catch (error) {
//     return error
//   }
// }

export const FetchPlantListNew = async (params, token, Order) => {
  try {
    const newdate = `${params}T00:00:00+05:30`
    const encodedDate = encodeURIComponent(newdate)
    const response = await axios.get(
      //NEWurl + `api/plant?date=${encodedDate}&plantSizeOrder=${Order}`,
      NEWurl + `api/allplantdata?date=${encodedDate}&plantSizeOrder=${Order}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )

    console.log('FetchPlantListNew response:', response)

    return response
  } catch (error) {
    return error
  }
}

export const FetchPlantSearchNew = async (date, name, type, token, Order) => {
  try {
    const newdate = `${date}T00:00:00+05:30`
    const encodedDate = encodeURIComponent(newdate)
    const response = await axios.get(
      NEWurl +
        `api/allplantdata?date=${encodedDate}&plantNameSearch=${name}&plantType=${type}&plantSizeOrder=${Order}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )

    return response
  } catch (error) {
    return error
  }
}

export const FetchPlantByID = async (params, token, Order, plantId) => {
  try {
    const newdate = `${params}T00:00:00+05:30`
    console.log('dateeeeeeees', newdate)

    const encodedDate = encodeURIComponent(newdate)
    console.log('dateeeeeeee', encodedDate)

    const response = await axios.get(
      NEWurl +
        `api/allplantdata?date=${encodedDate}&plantSizeOrder=${Order}&plantId=${plantId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )

    return response
  } catch (error) {
    return error
  }
}

export const CreatenewplantNew = async (params, token) => {
  try {
    console.log('add Plat')

    // const response = await axios.post(NEWurl + 'api/plant', params, {
    const response = await axios.post(NEWurl + 'api/plantsv2', params, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}

export const DeletenewplantNew = async (params, token) => {
  try {
    const response = await axios.delete(NEWurl + 'api/plantsv2/' + params, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}
export const UpdatenewplantNew = async (params) => {
  try {
    const response = await axios.put(
      NEWurl + 'api/plantsv2/' + params?.Id,
      params?.values,
      { headers: { Authorization: `Bearer ${params?.token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchSensorListNew = async (token) => {
  try {
    const response = await axios.get(NEWurl + 'api/sensors', {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}

export const FetchPlantCountGraphNew = async (
  technicalDate,
  sortType,
  token,
  toDate
) => {
  try {
    const response = await axios.get(
      NEWurl +
        'api' +
        `/graph/plants-per-month?fromDate=${technicalDate}&period=${sortType}&toDate=${toDate}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchPlantSizeGraphNew = async (
  technicalDate,
  sortType,
  token,
  toDate
) => {
  try {
    const response = await axios.get(
      NEWurl +
        'api' +
        `/graph/plant-sizes-per-month?fromDate=${technicalDate}&period=${sortType}&toDate=${toDate}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchGraphByminimumguaranteeNew = async (
  PlantID,
  technicalDate,
  token,
  duration,
  TechnicalTodate
) => {
  try {
    const response = await axios.get(
      NEWurl +
        'api' +
        '/graph/minimum-guarantee-per-month?id=' +
        PlantID +
        `&period=${duration}&fromDate=${technicalDate}&toDate=${TechnicalTodate}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchDashboarddataNew = async (userId, token) => {
  try {
    const response = await axios.get(NEWurl + 'api/plantsv2', {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}

export const FetchGraphByInvesterguaranteeNew = async (
  PlantID,
  technicalDate,
  token,
  duration,
  TechnicalTodate
) => {
  try {
    const response = await axios.get(
      NEWurl +
        'api' +
        '/graph/investor-guarantee-per-month?id=' +
        PlantID +
        `&period=${duration}&fromDate=${technicalDate}&toDate=${TechnicalTodate}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const loginNew = async (params) => {
  console.log(params, 'login params')
  try {
    const response = await axios.post(NEWurl + 'api/users/login', {
      username: params.email,
      password: params.password,
      // deviceTypeId: '',
      // deviceName: '',
      // moduleId: '',
      // deviceUniqueKey: '',
    })
    console.log(response, 'login response')

    return response
  } catch (error) {
    return error
  }
}

export const FetchDeviceStatusNew = async (plantId, token) => {
  try {
    const response = await axios.get(
      NEWurl + `api/plant/device-status-v2/${plantId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )

    console.log('FetchDeviceStatusNew response:', response)

    return response
  } catch (error) {
    return error
  }
}

export const AddInternalUserNew = async (data, token) => {
  try {
    const response = await axios.post(NEWurl + 'api/users', data, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}

export const FetchUsersListNew = async (token, type = 'client') => {
  try {
    const response = await axios.get(
      NEWurl + `api/users?type=${type}&limit=10&offset=0`,
      { headers: { Authorization: `Bearer ${token}` } }
    )

    return response
  } catch (error) {
    return error
  }
}

export const FetchInternalUsersListNew = async (token) => {
  try {
    const response = await axios.get(
      NEWurl + `api/users?type=sub_admin&limit=10&offset=0`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const AddExternalUserNew = async (data, token) => {
  try {
    const response = await axios.post(NEWurl + 'api/users', data, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error.response
  }
}

export const DeleteUserNew = async (userId, token) => {
  try {
    const response = await axios.delete(NEWurl + `api/users/${userId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}

export const RemovePlantToUserNew = async (data, token) => {
  console.log(token, 'token----token')
  try {
    const response = await axios.delete(NEWurl + 'api/users/plant', {
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    })
    return response
  } catch (error) {
    return error
  }
}

export const AddPlantToUserNew = async (data, token) => {
  try {
    const response = await axios.post(NEWurl + 'api/users/plant', data, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}

export const FetchDeviceListNew = async (token) => {
  try {
    const response = await axios.get(NEWurl + 'api/device-types-v2', {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}

export const GetMonthlyInvoiceNew = async (
  plantId,
  token,
  fromDate,
  toDate
) => {
  try {
    const response = await axios.get(
      // NEWurl +
      // `http://localhost:6500/api/report-v2/getTaxInvoice/${plantId}/${fromDate}/${toDate}`,
      `https://staging-backend-v3-monitoring.de.energy/api/report-v2/getTaxInvoice/${plantId}/${fromDate}/${toDate}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const AddlogdtaNew = async (data, token) => {
  try {
    const postData = {
      ...data,
      duration: Array.isArray(data.timePeriods)
        ? data.timePeriods.join(' | ')
        : data.duration,
      multiplyingFactor: Number(data.multiplyingFactor) || undefined,
    }

    const response = await axios.post(
      NEWurl + 'api/demed-generation-logs',
      postData,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    return response
  } catch (error) {
    return error
  }
}

// Updated API function
export const UpdateLogDta = async (logId, data, token) => {
  try {
    const putData = {
      ...data,
      duration: Array.isArray(data.timePeriods)
        ? data.timePeriods.join(' | ')
        : data.duration,
      multiplyingFactor: Number(data.multiplyingFactor) || undefined,
    }

    const response = await axios.put(
      NEWurl + `api/demed-generation-logs/${logId}`,
      putData,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    console.log('response.data', response)

    return response
  } catch (error) {
    return error
  }
}

export const GetlogdtaNew = async (token) => {
  try {
    const response = await axios.get(NEWurl + 'api/demed-generation-logs', {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}

export const DeleteLogDta = async (logId, token) => {
  try {
    const response = await axios.delete(
      NEWurl + `api/demed-generation-logs/${logId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    return response
  } catch (error) {
    return error
  }
}

export const GetlogPlantNew = async (plantName, token) => {
  try {
    const response = await axios.get(
      NEWurl + `api/demed-generation-logs/${plantName}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    return response
  } catch (error) {
    return error
  }
}

export const GetMonthlyReportNew = async (plantId, token, fromDate, toDate) => {
  try {
    const response = await axios.get(
      NEWurl +
        `api/report-v2/getMonthlyReport/${plantId}/${fromDate}/${toDate}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const GetUserLogReportNew = async (token) => {
  try {
    console.log(token, 'token for the system logs')
    const response = await axios.get(NEWurl + `api/system-logs`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return response
  } catch (error) {
    return error
  }
}

export const GetUserLogReportByFilterNew = async (token, fromDate, toDate) => {
  try {
    const response = await axios.get(
      NEWurl +
        `api/system-logs?fromDate=${fromDate}&toDate=${toDate}&limit=10&offset=0`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const ChangePasswordNew = async (params, token) => {
  try {
    const response = await axios.post(
      NEWurl + 'api/users/change-password',
      {
        userId: params.userId,
        oldPassword: params.oldPassword,
        newPassword: params.newPassword,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchAllNotificationNew = async (token) => {
  try {
    const response = await axios.get(
      NEWurl + 'api/notifications/faulty?plantId=all'
      // { headers: { 'Authorization': `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const ClearAllNotificationNew = async (token, userId) => {
  try {
    const response = await axios.patch(
      NEWurl + 'api/notifications/clear-all-faulty',
      {
        userId: userId,
      }
      // { headers: { 'Authorization': `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchNotificationByPlantNew = async (plantId) => {
  try {
    const response = await axios.get(
      NEWurl + 'api/notifications/faulty?plantId=' + plantId
      // { headers: { 'Authorization': `Bearer ${token}` } }
    )
    return response
  } catch (error) {
    return error
  }
}

export const ForgotPassword = async (params) => {
  try {
    const response = await axios.post(NEWurl + 'api/users/forgot-password', {
      email: params.email,
    })
    return response
  } catch (error) {
    return error
  }
}

export const getAutomationStatus = async (plantId) => {
  try {
    const response = await fetch(
      `https://staging-backend-v3-express.de.energy/api/invoices/email/automation/${plantId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    if (!response.ok) {
      throw new Error('Failed to fetch automation status')
    }

    const data = await response.json()
    console.log('isAutomated,', data)

    return data.data.automation
  } catch (error) {
    console.error('Error fetching automation status:', error)
    return error
  }
}

export const updateAutomationStatus = async (plantId, newStatus) => {
  try {
    const response = await fetch(
      'https://staging-backend-v3-express.de.energy/api/invoices/email/automation',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          plantId: plantId,
          automation: newStatus,
        }),
      }
    )

    if (!response.ok) {
      throw new Error('Network response was not ok')
    }

    const data = await response.json()
    console.log('Success:', data)
  } catch (error) {
    console.error('Error:', error)
  }
}

export const FetchActivePowerData = async (
  plantId,
  startDate,
  endDate,
  duration,
  token
) => {
  if (duration === 'day') {
    duration = 'today'
  }
  // const baseUrl = 'https://staging-backend-v3-express.de.energy' // Fixed URL (added colon instead of space and a port number if needed)
  const baseUrl = 'https://staging-backend-v3-express.de.energy'
  let url = `${baseUrl}/api/activepower/?plantId=${plantId}&type=ActivePower`
  if (duration === 'cust') {
    url += `&startDate=${startDate}&endDate=${endDate}&duration=cust`
  } else {
    url += `&startDate=${startDate}&duration=${duration}`
  }

  const response = await fetch(url)

  if (!response.ok) {
    throw new Error('Network response was not ok')
  }

  return response.json()
}

export const fetchGraphV2Data = async (
  plantId,
  dataType,
  fromDate,
  period,
  token,
  roofId = 'all',
  toDate = 'all',
  deviceId = 'all'
) => {
  try {
    // Validate token before making the request
    if (!token || token.trim() === '') {
      console.error('Token is empty or undefined')
      throw new Error('Authentication token is missing or invalid')
    }

    //const url = `http://localhost:6500/api/graph-v2/${plantId}/${dataType}/${fromDate}/${period}/${roofId}/${toDate}/${deviceId}`
    //const url = `https://staging-backend-v3-express.de.energy/api/graph-v2/${plantId}/${dataType}/${fromDate}/${period}/${roofId}/${toDate}/${deviceId}`
    const url =
      NEWurl +
      `api/graph-v2/${plantId}/${dataType}/${fromDate}/${period}/${roofId}/${toDate}/${deviceId}`

    console.log('Fetching Graph V2 Data:', {
      url,
      dataType,
      period,
      fromDate,
      toDate,
      roofId,
      deviceId,
      tokenLength: token ? token.length : 0,
      tokenStartsWith: token ? token.substring(0, 20) + '...' : 'none',
    })

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })

    //console.log("fetchGrapbV2Data response:", response.data);

    return response.data
  } catch (error) {
    console.error('Unable to fetch Graph V2 data:', {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      url: error.config?.url,
    })
    throw error
  }
}

export const fetchPlantOpData = async (date, token, order, plantId) => {
  try {
    const response = await axios.get(NEWurl + `api/allplantdata`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        date: date,
        plantSizeOrder: order,
        plantId: plantId,
      },
    })
    return response
  } catch (error) {
    console.error('Unable to fetch plant operational data')
    throw error
  }
}

export const fetchGraphV2aggr = async (
  dataType,
  fromDate,
  period,
  token,
  toDate = 'all'
) => {
  try {
    const url =
      NEWurl +
      `api/graph-v2/aggregated/${dataType}/${fromDate}/${period}/${toDate}`
    //const url = `http://localhost:6500/api/graph-v2/aggregated/${dataType}/${fromDate}/${period}/${toDate}`;
    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    })
    console.log('fetchGraphV2aggr response:', response.data)

    return response.data
  } catch (error) {
    console.error('Unable to fetch Graph V2 aggregated data:', error)
    throw error
  }
}

export const fetchPlantReportData = async (startDate, endDate) => {
  try {
    const response = await axios.get(
      `${expressURL}/api/plantreport?startDate=${startDate}&endDate=${endDate}`
    )
    if (response.data.success) {
      return { data: response.data.data, summary: response.data.summary }
    } else {
      throw new Error('API returned unsuccessful response')
    }
  } catch (error) {
    throw new Error(`Failed to fetch plant data: ${error.message}`)
  }
}

// Fetched Live Data - Real-time device information
export const FetchLiveDeviceData = async (plantId, deviceId, token) => {
  try {
    const response = await axios.get(
      NEWurl + `api/livedivicedata/fetched/${plantId}/${deviceId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    console.log(`FetchLiveDeviceData (${deviceId}) response:`, response)
    return response.data
  } catch (error) {
    console.error(`Error fetching live device data for ${deviceId}:`, error)
    return {
      success: false,
      error: error.message || 'Failed to fetch live device data',
    }
  }
}

// Calculated Device Data - Historical calculated data comparing previous and current day
export const FetchCalculatedData = async (plantId, deviceId, token) => {
  try {
    const response = await axios.get(
      NEWurl + `api/livedivicedata/calculted/${plantId}/${deviceId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    console.log(`FetchCalculatedData (${deviceId}) response:`, response)
    return response.data
  } catch (error) {
    console.error(`Error fetching calculated data for ${deviceId}:`, error)
    return {
      success: false,
      error: error.message || 'Failed to fetch calculated data',
    }
  }
}

// Batch fetch all live device data for a plant
export const FetchAllLiveDeviceData = async (plantId, token) => {
  try {
    const deviceIds = ['INV-001', 'SNS-001']
    const promises = deviceIds.map((deviceId) =>
      FetchLiveDeviceData(plantId, deviceId, token)
    )
    const results = await Promise.all(promises)

    return {
      success: true,
      data: {
        'INV-001': results[0],
        'SNS-001': results[1],
      },
    }
  } catch (error) {
    console.error('Error fetching all live device data:', error)
    return {
      success: false,
      error: error.message || 'Failed to fetch all live device data',
    }
  }
}

// Batch fetch all calculated data for a plant
export const FetchAllCalculatedData = async (plantId, token) => {
  try {
    const deviceIds = ['INV-001', 'INV-002', 'MTR-001']
    const promises = deviceIds.map((deviceId) =>
      FetchCalculatedData(plantId, deviceId, token)
    )
    const results = await Promise.all(promises)

    return {
      success: true,
      data: {
        'INV-001': results[0],
        'INV-002': results[1],
        'MTR-001': results[2],
      },
    }
  } catch (error) {
    console.error('Error fetching all calculated data:', error)
    return {
      success: false,
      error: error.message || 'Failed to fetch all calculated data',
    }
  }
}

// Fetch all calculated inverters for a plant
export const FetchCalculatedInvertersForPlant = async (plantId, token) => {
  try {
    const response = await axios.get(
      NEWurl + `api/livedivicedata/calculated/inverters/${plantId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    console.log('FetchCalculatedInvertersForPlant response:', response)
    return response.data
  } catch (error) {
    console.error('Error fetching calculated inverters for plant:', error)
    return {
      success: false,
      error: error.message || 'Failed to fetch calculated inverters',
    }
  }
}

// Fetch all live inverters data for a plant (real-time power monitoring)
export const FetchAllInvertersLiveData = async (plantId, token) => {
  try {
    const response = await axios.get(
      NEWurl + `api/livedivicedata/fetched/${plantId}/ALL-INVERTERS`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    console.log('FetchAllInvertersLiveData response:', response)
    return response.data
  } catch (error) {
    console.error('Error fetching all inverters live data:', error)
    return {
      success: false,
      error: error.message || 'Failed to fetch all inverters live data',
    }
  }
}
